
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((233|569|871)7|1953|2289|3901|4151|4505|7009|8993|9625)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
